import React from "react";
import ErrorPage from "../commons/ErrorPage/ErrorPage";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import reducer from "./reducers";
import saga from "./sagas";
import createSagaMiddleware from "redux-saga";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { PersistGate } from "redux-persist/integration/react";

const sagaMiddleware = createSagaMiddleware();

// export default function(initialState = {}) {
//   // Middleware and Enhancers
//   const enhancers = [applyMiddleware(sagaMiddleware)];

//   // Persisting state
//   const persistConfig = {
//     key: "rlsp",
//     storage
//   };
//   const persistedReducer = persistReducer(persistConfig, rootReducer);

//   const store = createStore(
//     persistedReducer,
//     initialState,
//     compose(...enhancers)
//   );
//   const persistor = persistStore(store);

//   sagaMiddleware.run(sagas);

//   return { store, persistor };
// }

const createProvider = () => {
  const sagaMiddleware = createSagaMiddleware();
  const enhancers = [applyMiddleware(sagaMiddleware)];

  // Persisting state
  const persistConfig = {
    key: "rlsp",
    storage,
    blacklist: ["auth", "dashboard"]
  };
  const persistedReducer = persistReducer(persistConfig, reducer);

  class AppProvider extends React.Component {
    constructor(props) {
      super(props);
      this.showError = this.showError.bind(this);
      this.state = { error: null };

      const catchingReducer = (state, action) => {
        try {
          return persistedReducer(state, action);
        } catch (e) {
          this.showError(e);
          return state;
        }
      };

      this.store = createStore(catchingReducer, {}, compose(...enhancers));

      this.persistor = persistStore(this.store);

      // this.store = createStore(catchingReducer, middleware);
      // .toPromise() is for redux-saga@1.0.0-beta.2, it has much nicer error stack
      const sagaTask = sagaMiddleware.run(saga).toPromise();
      sagaTask.catch(this.showError);
    }

    componentDidCatch(error) {
      this.showError(error);
    }

    showError(error) {
      /*
       * This can be called even before component mounted, since there can be error in the first round of
       * reducer when creating store. And we definitely dont want to create store as late as in componentDidMount.
       * Hence, this small "helper" to simplify architecture. Which is no big deal,
       * its used only for critical error state when app cannot continue anyway.
       */
      if (this.updater.isMounted(this)) {
        this.setState({ error });
      } else {
        this.state = { error };
      }
    }

    render() {
      if (this.state.error) {
        // if (process.env.NODE_ENV === "development") {
        //   return <ErrorPage error={this.state.error} />;
        // }

        return <ErrorPage error={this.state.error} />;
      }

      return (
        <Provider {...this.props} store={this.store}>
          <PersistGate loading={null} persistor={this.persistor}>
            {this.props.children}
          </PersistGate>
        </Provider>
      );
    }
  }

  return AppProvider;
};

export default createProvider;
